import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components'


const MainDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  width: 100vw;
  height: 100vh;
  
  /* background-color: rgba(144, 45, 19, .3); */
  /* background-color:   rgba(19, 142, 243, .3); */

  /* z-index: 2; */


  transition: .2s ease-out;
`


class Verify extends React.Component{
//   _onReady(event) {
    // access to player in all event handlers via event.target
    // event.target.pauseVideo();
//   }

    constructor(props){
        super(props)
        this.state = {
        };
    }
    componentDidMount(){
        console.log('Did mount')
        console.log(this.props.location.pathname)

        let link = this.props.location.pathname
        let username = link.split('/')[4]
        let token = link.split('/')[5]
        console.log(username, token)

    }

  render(){
      console.log(this.props)
    //   console.log(this.props.location.pathname)
      return(
          <MainDiv >
            <div style={{color: 'white'}}>
              <a href={'http://gmail.com'}><img src={'https://www.freepnglogos.com/uploads/logo-gmail-png/logo-gmail-png-image-gmail-logo-gta-wiki-the-grand-theft-auto-4.png'}/></a>
            </div>
          </MainDiv>
      )
    //   return <div>{this.props.logged_in ? this.logged_in_nav() : this.logged_out_nav}</div>;  
  }
  
}

export default Verify;

// Nav.propTypes = {
//   logged_in: PropTypes.bool.isRequired,
//   display_form: PropTypes.func.isRequired,
//   handle_logout: PropTypes.func.isRequired
// };